import React, { useRef } from "react"
import { FieldValues, RegisterOptions } from "react-hook-form"
import { Loader } from "@mantine/core"

import { TextInput } from "@/components"
import classes from "@/components/TextWithPlaceholders/TextInputWithPlaceholders.module.css"
import { PlaceholderButtonMenu } from "@/pages/texting/components/PlaceholdersMenuDropdown/PlaceholdersMenuDropdown"
import { Placeholder as DjangoPlaceholder } from "@/types/djangio"
import {
    iconList,
    TextWithPlaceholders,
    useTextWithPlaceholders,
} from "@/components/TextWithPlaceholders/TextWithPlaceholders"

interface Props {
    name: string
    label: string
    placeholder?: string
    rules: Omit<RegisterOptions<FieldValues, string>, "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled">
    placeholders: DjangoPlaceholder[]
    removeTargetPlaceholders: boolean
    dataCy?: string
    withAsterisk?: boolean
}

export const TextInputWithPlaceholders = ({
    placeholders,
    name,
    label,
    placeholder,
    rules,
    removeTargetPlaceholders,
    dataCy,
    withAsterisk = false,
}: Props) => {
    const { formattedPlaceholders, handleTextSelection, cursorTextRef } = useTextWithPlaceholders(
        placeholders,
        removeTargetPlaceholders,
    )

    return (
        <TextWithPlaceholders name={name} label={label} rules={rules} withAsterisk={withAsterisk}>
            <div className={classes.textContainer}>
                <TextInput
                    name={name}
                    data-cy={dataCy}
                    classNames={{ input: classes.noBorderBottom }}
                    rules={rules}
                    placeholder={placeholder}
                    onSelect={handleTextSelection}
                    showError={false}
                />
                <div className={classes.buttonsContainer}>
                    {formattedPlaceholders?.length > 0 ? (
                        <PlaceholderButtonMenu
                            iconsList={iconList}
                            placeholders={formattedPlaceholders}
                            cursorTextRef={cursorTextRef}
                            inputName={name}
                        />
                    ) : (
                        <Loader size={12} />
                    )}
                </div>
            </div>
        </TextWithPlaceholders>
    )
}
